module.exports = __webpack_public_path__ + "img/MCD_Kontakt_Quart_Teaser_Weber_01.f5398185.jpg";